import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsPage } from '@/components/NotificationSettings/NotificationSettingsPage';

export const Route = createFileRoute('/_authenticated/settings/notifications/')({
  component: NotificationSettingsPage,
});
